import { CHATS, PLAYER } from '../data';

export class ChatLogic {
  constructor(chatId) {
    this.chatId = chatId;
    this.chatData = CHATS[chatId];
    if (!this.chatData) {
      throw new Error(`Chat data not found for chatId: ${chatId}`);
    }
    this.messageCount = 0;
    this.currentSceneId = 0;
  }

  async getNext() {
    const currentScene = this.chatData.scenes[this.currentSceneId];

    if (!currentScene) {
      const unreadIndex = PLAYER.chats.unreadChatIds.indexOf(this.chatId);
      if (unreadIndex > -1) {
        PLAYER.chats.unreadChatIds.splice(unreadIndex, 1);
        PLAYER.chats.readChatIds.push(this.chatId);
      }
      return null;
    }

    const messageIndex = this.messageCount % (currentScene.messages.length + 1);

    if (messageIndex < currentScene.messages.length) {
      const message = currentScene.messages[messageIndex];
      this.messageCount++;
      return message;
    } else {
      return { choices: currentScene.choices };
    }
  }

  async makeChoice(app, choice) {
    if (choice.nextScene !== undefined) {
      this.currentSceneId = choice.nextScene;
      this.messageCount = 0;
    }

    if (choice.exitScene) {
      this.currentSceneId = null;
    }
  }
}
